const SECONDS_IN_ONE_DAY = 60 * 60 * 24;
const SECONDS_IN_TWO_DAYS = SECONDS_IN_ONE_DAY * 2;
const SECONDS_IN_ONE_WEEK = SECONDS_IN_ONE_DAY * 7;
const SECONDS_IN_TWO_WEEKS = SECONDS_IN_ONE_WEEK * 2;
const SECONDS_IN_ONE_MONTH = SECONDS_IN_ONE_WEEK * 4;
const SECONDS_IN_TWO_MONTHS = SECONDS_IN_ONE_MONTH * 2;
const SECONDS_IN_ONE_YEAR = SECONDS_IN_ONE_MONTH * 12;

const getVagueTimeAgo = (durationInSeconds: number): string => {
    if (durationInSeconds < SECONDS_IN_ONE_DAY) {
        return 'Today';
    }

    if (durationInSeconds >= SECONDS_IN_ONE_DAY && durationInSeconds < SECONDS_IN_TWO_DAYS) {
        return 'Yesterday';
    }

    if (durationInSeconds >= SECONDS_IN_TWO_DAYS && durationInSeconds < SECONDS_IN_TWO_WEEKS) {
        return Math.ceil(durationInSeconds / SECONDS_IN_ONE_DAY) + ' days ago';
    }

    if (durationInSeconds >= SECONDS_IN_TWO_WEEKS && durationInSeconds < SECONDS_IN_TWO_MONTHS) {
        return Math.ceil(durationInSeconds / SECONDS_IN_ONE_WEEK) + ' weeks ago';
    }

    if (durationInSeconds < SECONDS_IN_ONE_YEAR) {
        if (
            durationInSeconds % SECONDS_IN_ONE_MONTH >=
            SECONDS_IN_ONE_MONTH + SECONDS_IN_ONE_DAY * 8
        ) {
            return Math.ceil(durationInSeconds / SECONDS_IN_ONE_MONTH) + ' months ago';
        } else {
            return Math.round(durationInSeconds / SECONDS_IN_ONE_MONTH) + ' months ago';
        }
    }

    if (
        durationInSeconds >= SECONDS_IN_ONE_YEAR &&
        durationInSeconds < SECONDS_IN_ONE_YEAR + SECONDS_IN_ONE_MONTH * 6
    ) {
        return '1 year ago';
    }

    return Math.ceil(durationInSeconds / SECONDS_IN_ONE_YEAR) + ' years ago';
};

export default getVagueTimeAgo;
